import classNames from "classnames";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { Button } from "../../../components/buttons";
import { Select } from "../../../components/inputs";
import { endpoints } from "../../../constants/Endpoints";
import useData from "../../../hooks/useData";
import { allExams, selectedLanguage } from "../../../providers";
import { instance } from "../../../services/https/inceptors";
import { showToast } from "../../../utilities/toast";

const AddDppModal = ({ data, id, closeModal, setData }) => {
  const [dpp, setDpp] = useState([]);
  const [selectedDpp, setSelectedDpp] = useState([]);
  const exams = useRecoilValue(allExams);
  const language = useRecoilValue(selectedLanguage);

  const {
    departments,
    subjects,
    chapters,
    topics,
    selectedChapter,
    selectedDepartment,
    selectedExam,
    selectedSubject,
    selectedTopic,
    onChapterSelect,
    onDepartmentSelect,
    onExamSelect,
    onSubjectSelect,
    setSelectedTopic,
  } = useData();

  const getAllDpp = async () => {
    const res = await instance.get(endpoints.getAllDpp);
    const result = res.data.filter(
      (element2) =>
        !data?.dpp?.some((element1) => element1._id === element2._id)
    );
    setDpp(result);
  };

  useEffect(() => {
    getAllDpp();
  }, []);

  const selectDpp = (dpp) => {
    let clone = JSON.parse(JSON.stringify(selectedDpp));

    if (clone.some((item) => item._id === dpp._id)) {
      clone = clone.filter((chap) => chap._id !== dpp._id);
    } else clone.push(dpp);

    setSelectedDpp(clone);
  };

  const saveDPP = async () => {
    try {
      const res = await instance.post(endpoints.addCourseDPP, {
        dpp: selectedDpp,
        topicId: id,
      });

      if (res.data.data) {
        setData(res.data.data);
      }

      showToast({ type: "success", message: "Successfully Added DPP!" });
      closeModal();
    } catch (err) {
      showToast({ type: "error", message: err.response.data.message });
    }
  };

  const getSearchedDpp = async () => {
    let url = "";
    if (selectedExam) url += `?exam=${selectedExam}`;
    if (selectedDepartment) url += `&department=${selectedDepartment}`;
    if (selectedSubject) url += `&subject=${selectedSubject}`;
    if (selectedChapter) url += `&chapter=${selectedChapter}`;
    if (selectedTopic) url += `&topic=${selectedTopic}`;

    const res = await instance.get(endpoints.getAllDpp + url);

    const result = res.data.filter(
      (element2) =>
        !data?.dpp?.some((element1) => element1._id === element2._id)
    );

    setDpp(result);
  };

  return (
    <div className="backdrop fade show" style={{ background: "white" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header">
            {<h5 className="text-2xl font-semibold">Select DPP</h5>}

            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <div className="modal-body">
            <div className="container mt-3">
              <div className="d-flex justify-content-center mt-2 gap-3">
                <div className="w-20">
                  <Select
                    label="Exams"
                    value={selectedExam}
                    onChange={onExamSelect}
                  >
                    {exams?.map((exam) => (
                      <option key={exam.code} value={exam._id}>
                        {exam.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Departments"
                    value={selectedDepartment}
                    onChange={onDepartmentSelect}
                  >
                    {departments?.map((depart) => (
                      <option key={depart.code} value={depart._id}>
                        {depart.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Subject"
                    value={selectedSubject}
                    onChange={onSubjectSelect}
                  >
                    {subjects?.map((subj) => (
                      <option key={subj.code} value={subj._id}>
                        {subj.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Chapters"
                    value={selectedChapter}
                    onChange={onChapterSelect}
                  >
                    {chapters?.map((chap) => (
                      <option key={chap.code} value={chap._id}>
                        {chap.title}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="w-20">
                  <Select
                    label="Topics"
                    value={selectedTopic}
                    onChange={setSelectedTopic}
                  >
                    {topics?.map((topic) => (
                      <option key={topic.code} value={topic._id}>
                        {topic.title}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="d-flex justify-content-end w-100">
                <Button onClick={getSearchedDpp} width={20}>
                  Search
                </Button>
              </div>

              <hr className="my-5" />

              {dpp.length ? (
                <div className="d-flex flex-column gap-3">
                  {dpp?.map((dppItem) => (
                    <div
                      onClick={() => selectDpp(dppItem)}
                      className={`each-chapter d-flex c-pointer w-100 rounded ${
                        selectedDpp.some((ch) => ch._id === dppItem._id) &&
                        "selected-chapter"
                      }`}
                    >
                      <div
                        className={classNames("w-50 text-center border-r", {
                          "!bg-red-200": !dppItem?.name?.[language.value],
                        })}
                      >
                        {dppItem?.name?.[language.value] ??
                          `Not available in ${language.label}`}
                      </div>
                      <div className="w-50 text-center">
                        {dppItem.marks} marks
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  style={{ marginTop: "10rem" }}
                  className="text-center fs-5"
                >
                  No DPP Found!
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer gap-4">
            <div className="selected-length">
              <span> Selected</span>: {selectedDpp.length}
            </div>

            <button
              type="button"
              className="px-3 py-2 rounded-md bg-green-700 text-white"
              onClick={saveDPP}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDppModal;
